var mainNav = {
	$this: $( '.js-main-nav' ),
	setHeight: function( $submenu ) {

		// get height $submenu:
		var submenuHeight = $submenu.children( 'ul' ).outerHeight( true );

		// get height subsubmenu's
		var heightsArray = [];
		$submenu.find( '.submenu' ).each( function() {
			heightsArray.push( $( this ).outerHeight( true ) );
		} );

		var subsubmenuHeight = Math.max.apply( Math, heightsArray );
		if ( submenuHeight < subsubmenuHeight ) {
			 return subsubmenuHeight;
		}
		return submenuHeight;
	},
	openSubSubNav: function() {
		// met css translate
	},
	openSubNav: function() {

		if ( Modernizr.mq( '(min-width: 1024px)' ) ) {

			mainNav.$this.find( '.menu-item' ).mouseover( function( e ) {
				var $item = $( this );
				if ( $item.children( '.submenu' ).length > 0 ) {
					var $submenu = $item.children( '.submenu' );
					var newHeight = mainNav.setHeight( $submenu );
					$submenu.addClass( 'active' ).css( { 'height': newHeight } );
					$submenu.find( '.submenu' ).css( { 'height': newHeight } );
				}
			} );

			mainNav.$this.find( '.menu-item' ).mouseleave( function( e ) {
				var $item = $( this );
				if ( $item.children( '.submenu' ).length > 0 ) {
					var $submenu = $item.children( '.submenu' );
					$submenu.removeClass( 'active' ).removeAttr( 'style' );
				}
			} );

		}

	},
	mobile: {
		active: false,
		setScrollTop: 0,
		sticky: false,
		$btn: $('.js-main-nav .btn-mobile-menu'),
		$mobScroll: $('.js-main-nav .mob-scroll'),
		$mobContent: $( '.js-main-nav .mob-scroll > .mob-scroll-inner > .mob-scroll-content' ),
		openClose: function() {
			if ( !mainNav.mobile.active && Modernizr.mq( '(max-width:1023px)' ) ) {
				mainNav.mobile.$btn.on( 'click', function( e ) {
					e.preventDefault();
					if ( mainNav.mobile.$btn.hasClass( 'active') ) { // close:
						mainNav.mobile.$btn.removeClass( 'active' );
						mainNav.mobile.$mobContent.slideUp();
						mainNav.mobile.$mobScroll.removeAttr( 'style' );
						$( '.js-header' ).removeClass( 'zIndex' );
						$( 'body' ).removeClass( 'fixed' ).removeClass( 'keep-sticky' );
						$( '#container' ).removeAttr( 'style' );
						mainNav.mobile.sticky = false;
					} else { // open:
						mainNav.mobile.$btn.addClass( 'active' );
						if ( mainNav.$this.hasClass( 'sticky') ) {
							mainNav.mobile.sticky = true;
						}
						$( '.js-header' ).addClass( 'zIndex' );
						if ( mainNav.mobile.sticky ) {
							$( 'body' ).addClass( 'keep-sticky' );
						}
						mainNav.mobile.setScrollTop = $(window).scrollTop();
						$( '#container' ).css( { 'position': 'fixed', 'margin-top': -Math.abs( mainNav.mobile.setScrollTop ) } );
						$( 'body' ).addClass( 'fixed' );
						var windowHeight = $(window).height() - ( ($( '.js-main-nav' ).hasClass( 'sticky' )) ? $( '.js-header .header-top' ).height() : $( '.js-header' ).height() );
						mainNav.mobile.$mobScroll.height( windowHeight );
						mainNav.mobile.$mobContent.slideDown();
						$('body').icons.init('.svg-icon');
					}
				} );
				mainNav.mobile.active = true;
			}
		},
		openSub: function() {
			mainNav.$this.on( 'click', '.arrow2', function(e) {
					e.preventDefault();
					var $this  = $( this ),
							$submenu = $this.next( '.submenu' );
						if ($this.hasClass('open')) {
						 	$this.removeClass('open');
							//$submenu.slideUp();
							$submenu.css( 'height', '0px' );
						} else {
							$this.addClass('open');
							//$submenu.slideDown();
							var h = $submenu.children( 'ul' ).outerHeight( true );
							$submenu.css( 'height', h );
							$('body').icons.init('.svg-icon');
						}
				});
		}
	},
	init: function() {
		mainNav.openSubNav();
		mainNav.mobile.openClose();
		mainNav.mobile.openSub();
		$( '.main-nav li a' ).on( 'click', function( e ) {
			if ( $( e.target ).hasClass( 'arrow' ) ) {
				e.preventDefault();
			}
		} );
	},
};
